import { Component, OnInit,ViewChild, Output} from '@angular/core';
import { Map, LayerSpecification, NavigationControl } from 'maplibre-gl';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { FeatureCollection, Geometry, LineString, MultiPolygon, Point, Polygon } from 'geojson';
import { Feature} from 'geojson';
import * as d3 from 'd3';
import * as turf from '@turf/turf';
import { LegendComponent } from '../legend/legend.component';
import { HeatmatrixComponent } from '../heatmatrix/heatmatrix.component';
import { DiscreteLegendComponent } from '../discrete-legend/discrete-legend.component';
import { MapManagerService } from '../services/map-manager/map-manager.service';
import { MathAux } from '../services/math-aux/math-aux';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeatmapType } from '../models/heatmap-type';
import { ColorType } from '../models/color-type';
import { Tempo } from '../models/tempo';
import { routerToMainService } from '../services/routerToMainService';
import { AlertListComponent } from '../alert-list/alert-list.component';
import { Alerta } from '../models/alerta';
import {EventGroups} from '../models/event-groups';
import { EventsConfig } from '../models/events-config';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegionDialogComponent } from './region-dialog/region-dialog.component';
import { MapboxDrawCustom } from './mapbox-aux/mapbox-draw-const';
import { TimespanService } from '../services/timespan/timespan.service';
import { DashboardToMapService } from 'src/app/dashboard/services/dashboard-to-map-service.service';
import { Analise } from 'src/app/dashboard/models/analise';
import { SocketIoServerService } from '../services/socket-io-server/socket-io-server.service';
import { HeuristicService } from '../../routes/services/heuristic/heuristic.service';
import { ExportMapService } from '../services/export-map/export-map.service';

import * as mapboxgl_draw from "@mapbox/mapbox-gl-draw"
import { ToolbarMenuIndices } from '../models/toolbar-menu-indices';
import { VoronoiEventsCount } from '../models/voronoi-events-count';
import { VoronoiService } from '../services/voronoi/voronoi.service';
import { finalize } from 'rxjs/operators';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Overlay } from '@angular/cdk/overlay';
import { LayerParams } from './layer-manager';
import { RainCalendarItem } from 'src/app/shared/models/interfaces/rain-calendar-item';
import { RainCalendarSelectionType } from 'src/app/shared/models/enums/rain-calendar-selection-type';
import { LegendGroupComponent } from '../legend-group/legend-group.component';
import { MapLayer } from '../layers/map-layer';
import { HeatmapLayer } from '../layers/heatmap-layer/heatmap-layer';
import { LineLayer } from '../layers/line-layer/line-layer';
import { NeighborhoodLayer } from '../layers/neighborhood-layer/neighborhood-layer';
import { VoronoiLayer } from '../layers/voronoi-layer/voronoi-layer';
import { CameraLayer } from '../layers/camera-layer/camera-layer';
import { PointHighlightLayer } from '../layers/point-highlight-layer/point-highlight-layer';
import { PolygonHighlightLayer } from '../layers/polygon-highlight-layer/polygon-highlight-layer';
import { MapConfig, MapConfigDetails } from '../models/map-config';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';
import { EventHeatmapLayer } from '../layers/event-heatmap-layer/event-heatmap-layer';
import { NormalizerAux } from '../services/normalizer-aux/normalizer-aux';
import { CommunityService } from '../community/community.service';
import { getPredictedRainValue, getStationWeights } from '../utils/rain-interpolator';
import { MarkerLayer } from '../layers/marker-layer/marker-layer';
import { GridWithQuantiles } from '../models/altitude';
import { GenericHeatmapLayer } from '../layers/generic-heatmap-layer/generic-heatmap-layer';
import { CircleLayer } from '../layers/circle-layer/circle-layer';
import { LandslideLegendGroupComponent } from '../landslide-legend-group/landslide-legend-group.component';
import { StationMarkerBuilder } from '../layers/marker-builder/station-marker-builder/station-marker-builder';
import { EventMarkerBuilder } from '../layers/marker-builder/event-marker-builder/event-marker-builder';
import { LayerDisplayConfig } from '../models/layer-display-config';
import { Iteration } from '../models/iteration';
import { RouteIterationTableComponent } from '../route-iteration-table/route-iteration-table.component';
import { RouteChildrenEmitterService } from '../services/route-children-emitter/route-children-emitter.service';


/**
 * Componente da tela da análise instantânea.
 */
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements OnInit {

  // =======================================================================
  // ======================= Mapbox variables ==============================
  // =======================================================================  

  /** ID do elemento HTML que vai receber o mapa. */
  mapContainerId = 'map';
  
  /** URL do estilo CSS do mapa do maplibregl. */
  // style = 'mapbox://styles/mapbox/light-v10';
  style = 'https://api.maptiler.com/maps/2c7dc46e-8c76-48f4-9077-42dd5084d73d/style.json?key=eac08UlFLSV1G8mtYTJO';
  
  /** Latitude do ponto central de foco do map. */
  lat = -22.9060074;
  
  /** Longitude do ponto central de foco do map. */
  lng = -43.0615941;

  /** Referência ao objeto map do maplibregl */
  map: Map;

  // =======================================================================
  // ======================== Variáveis de heurística ======================
  // =======================================================================

  /** Número de guardas. */
  guards: number = 8;

  /** Número de viaturas interzona. */
  interzone: number = 2;

  /** Número de viaturas intrazona. */
  intrazone: number = 3;

  /** Tamanho máximo da rota interzona. */
  maxRouteInterzone: number = 3500.00;

  /** Tamanho máximo da rota intrazona. */
  maxRouteIntrazone: number = 2100.00;

  // ======================================================================
  // ========================== Observables ===============================
  // ======================================================================

  //$ mostra que a variável vai ser um observable

  /** Ouvinte da geometria das vias. */
  highways$: Observable<GeoJSON.FeatureCollection>;

  /** Ouvinte da geometria dos rios. */
  rivers$: Observable<FeatureCollection>;

  /** Ouvinte da geometria dos bairros. */
  neighborhoods$: Observable<FeatureCollection<MultiPolygon>>;

  /** Ouvinte do evento de carregamento dos dados da chuva em tempo real. */
  realTime$: Subscription;

  /** Ouvinte da geometria das células de voronoi, onde cada estação ocupa uma
   * e somente uma célula.
   */
  voronoi$: Observable<GeoJSON.FeatureCollection>;

  /** Observable da busca pelo objeto que tem o id_tempo, dada a data da chuva. */
  Tempos$: Observable<Tempo[]>;

  /** Observable da busca pelo objeto que tem o id_tempo, dada a data limite 
   * da janela de ocorrências. */
  TempoFinal$: Observable<Tempo[]>;

  /** Observable da busca pelo geojson das estações com os valores de chuva
   * no instante de tempo selecionado pelo usuário. */
  Chuva$: Observable<GeoJSON.FeatureCollection>;

  /** Observable da busca do geojson das ocorrências (chamadas de eventos anteriormente).
   * As ocorrências estão entre o instante da chuva e o instante definido nos campos
   * de limite.
   */
  Eventos$: Observable<GeoJSON.FeatureCollection<Point>>;

  /** Observable da busca dos alertas / avisos. Os alertas e avisos selecionados
   * são aqueles cujo intervalo de tempo de validade abrangem o instante de tempo
   * de chuva selecionado pelo usuário.
   */
  Alertas$: Observable<Alerta[]>;

  /**
   * Observable da busca das câmeras.
   */
  Cameras$: Observable<FeatureCollection<Point>>;

  /** Observable da busca da geometria das comunidades de Niterói. */
  communities$: Observable<FeatureCollection>;
  /**Observable de todos os dados da beborah */
  altitude$: Observable<GridWithQuantiles>;
  cluster2$: Observable<FeatureCollection>;
  cluster5$: Observable<FeatureCollection>;
  cluster6$: Observable<FeatureCollection>;
  cluster7$: Observable<FeatureCollection>;
  incident$: Observable<GridWithQuantiles>;
  conservationUnit$: Observable<FeatureCollection>;
  
  // ======================================================================
  // ============================== Data ==================================
  // ======================================================================

  /** Geometria das vias. */
  highwaysData: GeoJSON.FeatureCollection;

  /** Geometria dos rios. */
  riversData: FeatureCollection;

  /** Geometria dos limites dos bairros. */
  neighborhoodsData: FeatureCollection<MultiPolygon>;

  /** Geometria das comunidades. */
  communitiesData: FeatureCollection<MultiPolygon>;
  /** Outros dados da Deborah. */
  altitudeData: GridWithQuantiles;
  cluster2Data: FeatureCollection<Point>;
  cluster5Data: FeatureCollection<Point>;
  cluster6Data: FeatureCollection<Point>;
  cluster7Data: FeatureCollection<Point>;
  incidentData: GridWithQuantiles;
  conservationUnitData: FeatureCollection<MultiPolygon>;
  /** centroides dos bairros com os valores de chuva interpolados usando as estações. */
  calcNeighborhoods: Feature<Point>[];

  /** centroides das comunidades com os valores de chuva interpolados usando as estações. */
  calcCommunities: Feature<Point>[];

  /** Geometria das células de voronoi. Uma célula abriga uma estação. */
  voronoiData: GeoJSON.FeatureCollection;

  /** Geometria das câmeras de trânsito. */
  camerasData: FeatureCollection<Point>;

  /** Configuração dos controles das camadas na interface. */
  mapConfig: MapConfig = this.mapConfigService.instantMapConfig;

  HeatmapType = HeatmapType;
  
  /** Referência à análise que pode ter sido passada pela tela do dashboard, 
   * e será usada para inicializar os campos e camadas do mapa na interface.
   */
  analise: Analise;

  /** Geometria das ocorrências (chamadas antes de eventos) */
  eventsData: FeatureCollection<Point>;

  historyRoutesData: FeatureCollection<LineString | Point>;

  /** Alertas e avisos */
  alertsData: Alerta[];

  /** */
  neighborhoodFilteredRainData: FeatureCollection<Point> = {"type":"FeatureCollection","features":[]};

  /** Array de contagens de ocorrências por célula de voronoi dentro do intervalo de tempo de ocorrências. */
  voronoiEventsCount: VoronoiEventsCount[];

  /** Eventos que ocorreram em quaisquer datas que apresentaram um padrão de intensidades de chuvas selecionado pelo usuário. */
  rainPatternEvents: FeatureCollection<Point>;

  /** Nomes dos grupos de ocorrências. */
  eventGroups = Object.keys(EventGroups.groups)

  /** Número da próxima região poligonal a ser desenhada no mapa. */
  nRegiao = 0
  
  /** Array de coordenadas (pins) das viaturas policiais colocadas no mapa pelo usuário */
  patrolCars: Feature<Point>[] = [];

  /**
   * Limites de chuva em milímetros por hora (mm/h)
   * 
   * fraca:    chuva <  2.5
   * moderada: 2.5   >= chuva < 10
   * forte:    10    >= chuva < 50
   * violenta: chuva >= 50
   */
  rainThresholds: number[] = [2.5, 10, 50];

  /** Valor usado no cálculo da interpolação da chuva em um ponto específico
   * pelo método IDW (https://en.wikipedia.org/wiki/Inverse_distance_weighting)
   */
  p: number = 2;

  /** Evento que sinaliza a gravação dos valores dos campos de configuração
   * e das camadas do mapa.
   */
  @Output() saveMapConfig = new EventEmitter<MapConfig>()

  /** Nomes das colunas dos acumulados de chuva como são no BD e como devem
   * ser exibidos na interface.
   */
  timeColumns: {name: string, text: string}[] = [
    { name:'indice_pluv', text: 'Agora'},
    { name: 'quinzemin', text: '15 minutos'},
    { name: 'trintamin', text: '30 minutos'},
    { name: 'umahora', text: '1 Hora'},
    { name: 'seishoras', text: '6 Horas'},
    { name: 'dozehoras', text: '12 Horas'},
    { name: 'vintequatrohoras', text: '24 horas'},
    { name: 'quarentaoitohoras', text: '48 Horas'},
    { name: 'setentaduashoras', text: '72 Horas'},
    { name: 'noventaseishoras', text: '96 Horas'},
    { name: 'mes', text: '1 mês'}
  ]

  // =======================================================================
  // ============================ ViewChild ================================
  // =======================================================================

  /** Referência à legenda da chuva contínua. */
  @ViewChild("heatmapinter") legendinter : LegendComponent;

  /** Referência à legenda da chuva discreta. */
  @ViewChild("heatmapViasDiscrete") legendViasDiscrete: DiscreteLegendComponent;

  /** */
  @ViewChild("heatmapvias") legendvias: LegendComponent;

  /** Referência à legenda da contagem de ocorrências por célula de voronoi. */
  @ViewChild("voronoiEventsLegend") voronoiEventsLegend: LegendComponent;

  /** Referência à heatmatrix. */
  @ViewChild(HeatmatrixComponent) heatmatrix: HeatmatrixComponent;

  /** Referência à toolbar. */
  @ViewChild(ToolbarComponent) toolbar: ToolbarComponent;

  /** Referência à lista de alertas / avisos. */
  @ViewChild(AlertListComponent) alertList: AlertListComponent;

  /** Referência à imagem de backdrop das câmeras de trânsito. */
  @ViewChild("backdropImg") backdropImg: HTMLImageElement;

  /** Referência ao grupo de legendas */
  @ViewChild(LegendGroupComponent) legendGroup: LegendGroupComponent;

  @ViewChild(LandslideLegendGroupComponent) landslideLegendGroup: LandslideLegendGroupComponent;

  @ViewChild("routeIterationTable") routeIterationTable: RouteIterationTableComponent;

  // ======================================================================
  // ======================== Visibility variables ========================
  // ======================================================================

  /** Valor do atributo CSS visibility usado para controlar a exibição da heatmatrix. */
  tableVisibility = "visible"

  /** Indica se deve exibir a barra lateral (toolbar) ou não. */
  showSidebar = false;
  
  /** */
  segments_heatmap_rain: number[] = [];

  //Element switches
  /** Indica se o menu de pontos está aberto. */
  points_menu = false;

  /** Indica se o menu de linhas está aberto. */
  lines_menu = false;

  /** Indica se o menu da Deborah */
  deborahs_menu = false;

  /** Indica se o menu de sobreposições está aberto. */
  layers_menu = false;

  /** Indica se o menu de visualizações / tabelas está aberto. */
  apps_menu = false;

  /** Indica se a heatmatrix está visível. */
  heatmatrix_show = false;

  /** */
  datelist_show = false;

  /** Indica se a lista de alertas e avisos está visível. */
  alertlist_show = false;

  /** Indica se o calendário de chuvas está visível. */
  raincalendar_show = false;

  /**
   * Indica se a camada está ativa no mapa ou não.
   * 
   * - 0: estação
   * - 1: heatmap
   * - 2: vias
   * - 3: rios
   * - 4: bairros
   * - 5: voronoi
   * - 6: ocorrências 
   * - 7: câmeras
   * */
  // heatmap_type = [false, false, true, false, false, false, false, false];

  /** Dados das camadas com IDs de fonte e camada. */
  mapboxLayersData = [
    null,
    { 'sourceId': 'chuvas-grid', 'layerId': 'chuvas-grid' },
    { 'sourceId': 'highways-data-source', 'layerId': 'highways-line' },
    { 'sourceId': 'rivers-data-source', 'layerId': 'rivers-line' },
    { 'sourceId': 'neighborhood-data-source', 'layerId': 'neighborhoods-layer' },
    { 'sourceId': 'voronoi-data-source', 'layerId': 'voronoi-layer' },
    null,
  ];

  /** Referência ao conjunto de botões de controle do mapa (p. ex. criar e excluir polígonos) */
  map_draw: mapboxgl_draw;

  /** Controla a possibilidade de cliar e arrastar a heatmatrix. */
  heatmatrixDragDisabled = true;

  /** Controla a possibilidade de clicar e arrastar a lista de alertas e avisos. */
  alertListDragDisabled = true;

  /** Controla a possibilidade de clicar e arrastar o calendário de chuvas. */
  rainCalendarDragDisabled = true;

  /** Referência para controlar o backdrop, que tem o spinner de carregamento dos dados. */
  backdrop = this.createBackdrop();

  // ============================================================================
  // ========================= Layer painting callbacks =========================
  // ============================================================================

  stationHighlightLayer = new PointHighlightLayer('highlighted_station_source', 'highlighted_station_layer');

  neighborhoodHighlightLayer = new PolygonHighlightLayer(
    'highlighted_neighborhood_source',
    'highlighted_neighborhood_layer_line',
    'highlighted_neighborhood_layer_fill'
  );


  layers: LayerDisplayConfig[] = [
    {
      id: HeatmapType.STATIONS,
      layer: new MarkerLayer(
        new StationMarkerBuilder(
          this.setStationHighlight.bind(this)
        )
      ), 
      dataFunction: this.getStationLayerData.bind(this),
      beforeShow: this.removeStationHighlight.bind(this),
      updateLegendFunction: this.updateRainLegend.bind(this),
    },
    {
      id: HeatmapType.HEATMAP,
      layer: new HeatmapLayer('chuvas-grid', 'chuvas-grid'),
      dataFunction: this.getHeatmapLayerData.bind(this),
      updateLegendFunction: this.updateRainLegend.bind(this),
    },
    {
      id: HeatmapType.HIGHWAYS,
      layer: new LineLayer('highways-data-source', 'highways-line'),
      dataFunction: this.getHighwayLayerData.bind(this),
      updateLegendFunction: this.updateRainLegend.bind(this),
    },
    {
      id: HeatmapType.RIVERS,
      layer: new LineLayer('rivers-data-source', 'rivers-line'),
      dataFunction: this.getRiverLayerData.bind(this),
      updateLegendFunction: this.updateRainLegend.bind(this),
    },
    {
      id: HeatmapType.NEIGHBORHOOD,
      layer: new NeighborhoodLayer('neighborhood-data-source', 'neighborhood-layer'),
      beforeShow: this.removeNeighborhoodHighlight.bind(this),
      dataFunction: this.getNeighborhoodLayerData.bind(this),
      updateLegendFunction: this.updateRainLegend.bind(this),
    },
    {
      id: HeatmapType.VORONOI,
      layer: new VoronoiLayer('voronoi-data-source', 'voronoi-layer'),
      dataFunction: this.getVoronoiLayerData.bind(this),
      updateLegendFunction: this.updateVoronoiLegend.bind(this),
    },
    {
      id: HeatmapType.EVENTS,
      layer: new MarkerLayer(new EventMarkerBuilder(function() {})),
      dataFunction: this.getEventLayerData.bind(this),
      updateLegendFunction: this.updateEventsLegend.bind(this),
    },
    {
      id: HeatmapType.CAMERA,
      layer: new CameraLayer(),
      dataFunction: this.getCameraLayerData.bind(this),
      updateLegendFunction: this.updateCameraLegend.bind(this),
    },
    {
      id: HeatmapType.EVENTS_HEATMAP,
      layer: new EventHeatmapLayer('rain-pattern-events-source', 'rain-pattern-events-layer'),
      dataFunction: this.getEventHeatmapLayerData.bind(this),
      updateLegendFunction: this.updateEventHeatmapLegend.bind(this),
    },     
  ];

  // ===========================================================================

  /** Tipo de seleção de datas no calendário de chuvas para a análise instantânea. */
  rainCalendarSelectionType: RainCalendarSelectionType = RainCalendarSelectionType.SINGLE;

  includePointsButtonInMapDraw = true;

  /**
   * Construtor.
   * @param service serviço de busca das geometrias e dados das chuvas e ocorrências.
   * @param mapManager serviço que tem funções para processar os dados das chuvas e pintar as camadas do mapa.
   * @param snackBar snackbar para exibir mensagens relacionadas ao carregamento dos dados.
   * @param routerMessager serviço para compartilhar os dados entre componentes.
   * @param dialog usado para exibir dialogs do angular material.
   * @param routerReciever serviço usado para receber dados das análises do dashboard.
   * @param socketIo serviço que usa o socket.io na atualização da chuva em tempo real.
   * @param heuristicService serviço da heurística das rotas nas vias para atender as ocorrências.
   * @param voronoiService serviço de busca dos dados da contagem de ocorrências por célula de voronoi.
   * @param overlay overlay para exibir o spinner durante o carregamento dos dados.
   */
  constructor(protected service: ServiceService,
    public mapManager: MapManagerService,
    public snackBar: MatSnackBar,
    protected routerMessager: routerToMainService,
    public dialog: MatDialog,
    protected routerReciever: DashboardToMapService,
    protected socketIo: SocketIoServerService,
    protected heuristicService: HeuristicService,
    protected voronoiService: VoronoiService,
    private overlay: Overlay,
    protected mapConfigService: MapConfigService,
    protected exportMapService: ExportMapService,
    protected communityService: CommunityService,
    protected routeChildrenEmitterService: RouteChildrenEmitterService,
    protected timespanService: TimespanService) { }


  /**
   * Inicializa o mapa do maplibregl. Realiza tarefas como:
   * - definir ouvinte do botão de tempo real que está na barra de menu.
   * - inicializar uma instância do maplibregl.
   * - adicionar botões de controle do mapa (desenhar e remover polígonos, etc).
   * - carregar geometrias das vias, rios e bairros.
   */
  ngOnInit(): void {
    this.setRouterIdentity();

    this.map = new Map({
      container: this.mapContainerId,
      style: this.style,
      zoom: 11.4,
      center: [this.lng, this.lat],
      logoPosition: "top-right",
      preserveDrawingBuffer: true,
    });

    // this.map.addControl(new ExportControlComponent(() => { return this.mapConfig }), "bottom-right");
    this.map.addControl(new NavigationControl({showCompass: false}),"bottom-right");   //botões que controlam o zoom

    this.highways$ = this.service.getAll();
    this.rivers$ = this.service.getAllRivers();
    this.neighborhoods$ = this.service.getAllNeighborhoods();
    this.voronoi$ = this.service.getVoronoiPolygons();

    this.map.on('style.load', () => {

      this.map.getStyle().layers?.forEach((layer : LayerSpecification) => {
        if (layer.type === 'symbol') {
            this.map.removeLayer(layer.id);
        }
      });

      let listeners = [this.highways$, this.rivers$, this.neighborhoods$, this.voronoi$ ];
      
      forkJoin(listeners).subscribe(results => {
        let [ highways, rivers, neighborhoods, voronoi, ] = results;

        this.neighborhoodsData = neighborhoods as FeatureCollection<MultiPolygon>;

        this.voronoiData = voronoi;

        this.riversData = rivers;
        let riverLayerParams: LayerParams = {
          rainData: null,
          segmentsData: this.riversData,
        };
        let riverLayer = this.layers[HeatmapType.RIVERS].layer as LineLayer;
        riverLayer.setSource(this.map, riverLayerParams);

        this.highwaysData = highways;
        let highwayLayerParams: LayerParams = {
          rainData: null,
          segmentsData: this.highwaysData,
        };
        let highwayLayer = this.layers[HeatmapType.HIGHWAYS].layer as LineLayer;
        highwayLayer.setSource(this.map, highwayLayerParams);
        highwayLayer.show(this.map, highwayLayerParams);

        this.routerInit()
      });
    });

    this.map_draw = MapboxDrawCustom.createDraw(this.includePointsButtonInMapDraw);    

    // @see https://maplibre.org/news/2023-01-03-aws-maplibre-plugins/
    // @ts-ignore
    this.map.addControl(this.map_draw, "bottom-right");

    this.observeRouteChildrenEmitter();
  }

  protected observeRouteChildrenEmitter() {
    this.routeChildrenEmitterService.getObservable().subscribe(rows => {

      const selectedSegmentIds = rows.map(r => r['segment_id']);

      const features = this.historyRoutesData.features;

      // filtrar pelas linhas selecionadas
      const filteredSegments = features
        .filter(feature => selectedSegmentIds.includes(feature.properties['segmentId']) ||
          feature.geometry.type === 'Point'
        );

      let commonFilteredSegments: Feature<LineString | Point>[] = [];

      for (let i = 0; i < filteredSegments.length; i++) {
        for (let j = i + 1; j < filteredSegments.length; j++) {
          let fI = filteredSegments[i];
          let fJ = filteredSegments[j];

          let commonSegment = features.find(f => f.properties.iterationGroup == 2
            && JSON.stringify(f.properties.segmentIds) == JSON.stringify([
              fI.properties.segmentId, fJ.properties.segmentId
            ]));

          if (commonSegment != null) {
            commonFilteredSegments.push(commonSegment);
          }
        }
      }

      const displayedFc: FeatureCollection<LineString | Point> = {
        type: 'FeatureCollection',
        features: filteredSegments.concat(commonFilteredSegments),
      };

      this.map.removeLayer('history-routes');
      this.map.removeLayer('history-vehicles');
      this.map.removeSource('history-geometries-data-source');

      this.mapManager.setRouteMapSource(this.map, 'history-geometries-data-source', displayedFc);
      this.mapManager.setHistoryLayer(this.map, 'history-geometries-data-source', 'history-routes', 'history-vehicles', '#1126ba', 1, 4);
    });
  }

  /**
   * Inicializa a função de desenho das regiões poligonais no mapa.
   * Um polígono desenhado é adicionado à heatmatrix.
   * A chuva das estações é interpolada no polígono e é atualizada quando o
   * polígono é movido no mapa.
   * Também trata a criação e remoção dos pontos que representam as viaturas.
   */
  ngAfterViewInit(){

    const updateArea = (e:any) => {
      
      // Quando se arrasta o polígono por estações, o array e.features vem vazio,
      // e isso causa erros.
      if (e.features.length == 0) {
        return;
      }

      let name = "";
      // ================================ POLÍGONO ==================================== //
      const numCoordinates = e.features[0].geometry.coordinates[0].length;
      if (numCoordinates > 1) {
        if (e.type == 'draw.create'){
          // if(this.mapConfig.geojson.features.length > 0){
            this.openDialog().afterClosed().subscribe((result: { nomeRegiao: string; })=> {
              name = result.nomeRegiao;
              let newRegion = this.switchTypeOfPointFromPolygon(e.features[0],name)
              this.heatmatrix.addRegionToTable(newRegion)
              e.features[0].properties.nome_estacao_original = name
              let index = this.heatmatrix.displayState - 1
              MapboxDrawCustom.recolorFeature(this.map_draw,newRegion[index],this.mapConfig.geoData.selectedColumn)

              this.mapConfig.geoData.polygons.push(e.features[0]);
            });
        } else if (e.type == 'draw.update' || e.type == 'draw.delete'){
          let localindex = this.mapConfig.geoData.polygons.findIndex(val =>{
            return val.id == e.features[0].id
          })
          if (e.type == 'draw.update'){
            let newRegion = this.switchTypeOfPointFromPolygon(e.features[0],this.mapConfig.geoData.polygons[localindex].properties.nome_estacao_original)
            this.heatmatrix.updateRegionFromTable(newRegion)
            e.features[0].properties.nome_estacao_original = this.mapConfig.geoData.polygons[localindex].properties.nome_estacao_original
            let index = this.heatmatrix.displayState - 1
            MapboxDrawCustom.recolorFeature(this.map_draw,newRegion[index],this.mapConfig.geoData.selectedColumn)
            this.mapConfig.geoData.polygons[localindex] = e.features[0];
          }else{
            this.heatmatrix.removeRegionFromTable([e.features[0]])
            this.map_draw.delete(e.features[0].id)
            this.mapConfig.geoData.polygons = this.mapConfig.geoData.polygons.filter(val => val.id != e.features[0].id);
          }
        }
      }
      // ==================================== PONTO ===================================== /
      else {
        if (e.type == 'draw.create') {
          this.patrolCars.push(e.features[0]);
        }
        else if (e.type == 'draw.update') {
          let index = this.patrolCars.findIndex(point => point.id == e.features[0].id);
          this.patrolCars[index] = e.features[0];
        }
        else if (e.type == 'draw.delete') {
          let index = this.patrolCars.findIndex(point => point.id == e.features[0].id);
          this.patrolCars.splice(index, 1);
        }
      }
    }

    this.map.on('draw.create', updateArea);
    this.map.on('draw.delete', updateArea);
    this.map.on('draw.update', updateArea);
  }

  /** Indica se há dados de chuvas das estações. */
  get hasRainData() {
    return this.mapConfig?.geoData.filteredStations?.features.length > 0;
  }

  /** Indica se há dados das ocorrências. */
  get hasEventData() {
    return this.eventsData?.features?.length > 0;
  }

  /** Indica se há dados das câmeras. */
  get hasCameraData() {
    return this.camerasData?.features?.length > 0;
  }

  /** Indica se há dados de contagem de ocorrências por célula de voronoi. */
  get hasVoronoiEventsCount() {
    return this.voronoiEventsCount?.length > 0;
  }

  /** Indica se há dados de alertas e avisos. */
  get hasAlertData() {
    return this.alertsData?.length > 0;
  }

  get hasRainPatternEventsData() {
    return this.rainPatternEvents?.features?.length > 0;
  }

  /**
   * Trata a notificação sobre a carga de novos alertas.
   * Busca os dados do alerta.
   */
  onNewAlertsAvailable() {

    let datetime = this.timespanService.formatDatetime(new Date());
    this.service
      .getTimeByHour(datetime)
      .subscribe((tempo: Tempo) => {
        this.getAlerts(tempo);
      });
  }

  /**
   * 
   * @returns 
   */
  getToolbar() {
    return this.toolbar;
  }

  /**
   * Abre um dialog de criação de região poligonal.
   * @returns referência ao dialog aberto.
   */
  openDialog(): MatDialogRef<RegionDialogComponent, any> {
    const dialogRef = this.dialog.open(RegionDialogComponent, {
      width: '250px',
      data: {nomeRegiao:"região"+this.nRegiao}
    });

    return dialogRef

  }


  /**
   * Alterna a visibilidade da heatmatrix.
   * @param $event 
   */
  switchTable($event:any){
    this.heatmatrix_show = !this.heatmatrix_show
    this.heatmatrix.changeView()
  }


  /**
   * Alterna a visibilidade da lista de alertas / avisos.
   * @param $event 
   */
  switchAlertList($event:any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.alertlist_show = !this.alertlist_show;
    this.alertList.changeView();
  }

  /**
   * Alterna entre exibir / esconder o calendário de chuva.
   * @param $event evento de click no botão
   */
  switchRainCalendar($event: Event) {
    $event.stopPropagation();
    $event.preventDefault();

    this.raincalendar_show = ! this.raincalendar_show;
  }

  /**
   * Busca os dados de chuva, alertas e avisos, eventos, eventos por célula de voronoi etc.
   * @param mapConfig possui os valores dos campos da toolbar para buscar os 
   *    registros e colorir as camadas.
   */
  onNewTimeSearch() {

    this.showBackdrop();

    let { startDatetime: datetime, endDatetime: eventsLimitDatetime, 
      newSearch } = this.mapConfig.time;

    this.Tempos$ = this.service.getTimeByHour(datetime);
    this.TempoFinal$ = this.service.getTimeByHour(eventsLimitDatetime);

    let tempos = [
      this.Tempos$,
      this.TempoFinal$
    ];

    forkJoin(tempos).subscribe((val) => {
      if(val[0].length == 0 || val[1].length == 0) {
        this.hideBackdrop();
        this.onNoTimeFound();
      }
      else {
        this.eraseDateList();
        this.mapConfig.time.tempo = [val[0][0], val[1][0]];
        let [ tempo, tempoFinal ] = this.mapConfig.time.tempo; 
        this.getAlerts(tempo);
        this.getRainValues(tempo.id_tempo, newSearch);
        this.toolbar.getSessionList(tempo.dia, tempo.mes, tempo.ano);

        let temTempoFinal = val[1].length > 0;

        if (!temTempoFinal) {
          this.getEventValues(tempo.id_tempo);
        }
        else {
          this.getEventValues(tempo.id_tempo, tempoFinal.id_tempo);
        }

        this.voronoiService
          .getEventsCountPerVoronoiCell(datetime, eventsLimitDatetime)
          .subscribe((result: VoronoiEventsCount[]) => {
            // this.voronoiEventsCount.emit(result)
            this.onVoronoiEventsCount(result);
          });

        this.getRainClassesFromCameras();

        let formatedmin,formatedhour,formatedfinalmin,formatedfinalhour,formatedday,formatedmonth;
        if (tempo.minuto < 10){formatedmin = "0"+tempo.minuto} else {formatedmin = tempo.minuto}
        if (tempo.hora < 10){formatedhour = "0"+tempo.hora} else {formatedhour = tempo.hora}
        if (tempo.dia < 10){formatedday = "0"+tempo.dia} else {formatedday = tempo.dia}
        if (tempo.mes < 10){formatedmonth = "0"+tempo.mes} else {formatedmonth = tempo.mes}
        this.snackBar.open(`Exibindo dados do dia ${formatedday}/${formatedmonth}/${tempo.ano}  ás ${formatedhour}:${formatedmin}`,"",{duration: 6000});
      }
    });
  }

  /**
   * Busca os dados dos alertas e avisos que ocorreram no tempo informado, e emite esses dados buscados.
   *
   * @param timeId o tempo sendo buscado
   */
   getAlerts(time: Tempo) {
    let tooFar = false; // variável que vai dizer se vale a pena buscar alertas/avisos inacabados
    if(new Date().getTime() - this.timespanService.tempoToDate(time).getTime() > 864000000){
      //864000000 é o numero de milisegundos em 10 dias
      tooFar = true;
    }
    this.Alertas$ = this.service.getAlertsByTimeId(time.id_tempo,tooFar,this.toolbar.enabledRT);

    this.Alertas$.subscribe(val => {
      this.alertsData = val;
      this.onAlertsFetched([val, time]);
    });
  }

  /**
   * Busca os registros de chuva no instante informado.
   * @param id_tempo id_tempo da busca
   * @param newSearch controla o reset de certas funcionalidades (Ex. Datelist da heatmatrix)
   */
  getRainValues(id_tempo: number, newSearch: boolean){
    this.Chuva$ = this.service.getRainDataByTimeId(id_tempo);
    this.Chuva$
      .pipe(finalize(() => {

        this.hideBackdrop();
      }))
      .subscribe(val =>{

        this.mapConfig.geoData.stations = val as FeatureCollection<GeoJSON.Point>;
        this.mapConfig.geoData.filteredStations = this.filterRainData();
        this.updateHeatMap(true);
    });
  }

  /**
   * Filtra os registros de chuva.
   * @returns registros de chuva filtrados.
   */
  protected filterRainData() {

    let { dataSource, completeness } = this.mapConfig.dataFilter;
    let { stations } = this.mapConfig.geoData

    // filtros
    
    // fonte dos dados
    const dataSourceFilter = (f: Feature) => dataSource.includes(f.properties.fonte);
    
    // porcentagem de completude
    const completenessFilter = (f: Feature) => {
      return this.timeColumns.every(({name}) => {
        return f.properties[`porcent_${name}`] >= completeness;
      });
    };

    let filteredGeojson: FeatureCollection<Point> = {
      'type': 'FeatureCollection',
      'features': stations.features
        .filter(dataSourceFilter)
        .filter(completenessFilter)
    };
    return filteredGeojson;
  }

  /**
   * Busca os registros dos eventos que ocorreram no tempo específico e atualiza o eventEmitter
   * rainEvents, passando esses registros recuperados.
   *
   * @param time_id id do tempo específico.
   */
  getEventValues(time_id: number, end_time_id?: number) {
    let endTimeId = end_time_id;
    this.Eventos$ = this.service.getEventDataByTimeId(time_id,endTimeId);
    this.Eventos$.subscribe(eventData => {
      this.onEventDataReceived(eventData);
    });
  }

  /**
   * Trata o recebimento dos dados das ocorrências.
   * @param eventData feature collection das ocorrências
   */
  onEventDataReceived(eventData: FeatureCollection<Point>) {

    const config: EventsConfig = {'events': eventData};
    this.eventsData = eventData;
    const active = this.mapConfig.layer.list[HeatmapType.EVENTS].isActive
    const hasEventData = this.hasEventData;
    const status = active && hasEventData;

    this.toggleLayer(HeatmapType.EVENTS, status);
  }

  /**
   * Busca as imagens capturadas pelas câmeras no instante atual com as respectivas
   * previsões de alagamento.
   */
  getRainClassesFromCameras() {

    const { startDatetime, } = this.mapConfig.time;
    this.service.getRainClassesFromCameras(startDatetime)
      .subscribe(classifications => {

        this.camerasData = classifications;
        let active = this.mapConfig.layer.list[HeatmapType.CAMERA].isActive;
        let hasCameraData = this.hasCameraData;
        let status = active && hasCameraData;
        this.toggleLayer(HeatmapType.CAMERA, status);
      });
  }


  /**
   * Cria uma overlay com backdrop. O conteúdo é centralizado horizontalmente e verticalmente na tela.
   * A classe dark-backdrop precisou ser definida no arquivo raiz styles.css para funcionar.
   */
  private createBackdrop() {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    })
  }

  /**
   * Exibe o backdrop com um spinner centraliado
   */
  private showBackdrop() {
    this.backdrop.attach(new ComponentPortal(MatSpinner));
  }

  /**
   * Esconde o backdrop com o spinner
   */
  private hideBackdrop() {
    this.backdrop.detach();
  }

  /**
   * Trata a alteração nos campos da toolbar, filtrando os registros das estações
   * localmente.
   * @param mapConfig valores atualizados da configuração do mapa.
   */
  onMapConfigChanged() {

    this.mapConfig.geoData.filteredStations = this.filterRainData();
    this.updateHeatMap(false);
  }

  /**
   * Atualiza o mapa para exibir os heatmaps. Também dispara a atualização da heatmatrix.
   *
   * @param response dados das estações, tipo de heatmap a ser exibido,
   *  tamanho do quadrado da interpolação em Km, percentis de índices pluviométricos, indicador sobre
   *  o tipo do heatmap das vias ser discreto ou não, percentis dos índices pluviométricos discretos.
   */
  updateHeatMap(newSearch: boolean) {
    
    let { filteredStations: rainData, selectedColumn } = this.mapConfig.geoData;
    let { tempo } = this.mapConfig.time;
    let { tilesizeInKm, percentile, list } = this.mapConfig.layer;
  
    // Limpa e inicia a heatmatrix.
    this.heatmatrix.reset(newSearch, tempo, selectedColumn);

    // Remove a camada das rotas
    this.clearAllRoutes();

    // Inicia a alert list
    this.alertList.tempo = tempo[0];
  
    // Não há registros de estações
    if (rainData.features.length == 0) {

      this.onNoRainDataFound();
      return;
    }

    // Ajusta coordenadas e acumulados de chuva das estações.
    rainData = this.mapManager.initialize(
      rainData, selectedColumn, percentile, list[HeatmapType.STATIONS].color, 
      this.timeColumns.map( (val)=>{ return val.name })
    );
    
    // Calcula interpolação das chuvas no bairro.
    this.calcNeighborhoods = this.interpolateOnPolygons(
      rainData, 
      this.neighborhoodsData, 
      this.timeColumns, 
      percentile as [number, number],
      HeatmapType.NEIGHBORHOOD);

    for (let centroid of this.calcNeighborhoods) {
      centroid.properties['neighborhood'] = true;
    }

    // this.calcNeighborhoods = this.calcNeighborhoodData();
    this.calcNeighborhoods.sort((a,b)=>a.properties[selectedColumn] - b.properties[selectedColumn])

    this.heatmatrix.updateTable(rainData.features, this.calcNeighborhoods);
    
    // Adiciona os polígonos previamente desenhados ao mapa.
    this.mapConfig.geoData.polygons.forEach( val=>{
      this.reloadArea(val);
    });
  
    // Para estações que têm um acumulado de chuva igual a null, a entrada correspondente
    // em getIndicesPluv será NaN. Por isso, devemos filtrar estações com o selectedTimestamp
    // igual a null. 
    let notNullFeatures = rainData.features.filter(station => station.properties[selectedColumn] != null);
    let notNullRainData: FeatureCollection<Point> = { "type": "FeatureCollection", "features": notNullFeatures } 
    let indicesPluv = this.mapManager.getIndicesPluv(notNullRainData,selectedColumn);
  
    // calculando os índices pluviométricos para as estações inicialmente, independente de ter layers ativas ou não.
    // middleIndicesPluv pode ser sobrescrito caso haja layers ativas.
    let middleIndicesPluv = MathAux.createMiddleData(indicesPluv, percentile);
    this.mapConfig.geoData.middleIndicesPluv = middleIndicesPluv;

    this.updateRainLayers();

    return;
  }
  
  /**
   * Trata o caso em que nenhum registro de chuva foi obtido no tempo específico.
   * Reinicia o objeto mapConfig, as legendas, a heat matrix, e as camadas com valores nulos.
   */
  protected onNoRainDataFound() {

    this.mapConfig.geoData.middleIndicesPluv = null;
    this.calcNeighborhoods = null;

    this.snackBar.open("Nenhuma Informação Recebida", "", { duration: 3000 });
    this.legendGroup.updateRainLegends(this.mapConfig);
    this.emptyHeatmatrix();

    this.resetRainLayers();
    this.mapConfig.layer.list[HeatmapType.STATIONS].isActive = false;
    this.mapConfig.layer.list[HeatmapType.HEATMAP].isActive = false;
  }

  /**
   * Trata a ocorrência de uma busca de um tempo que não tem registros
   * de chuva. 
   */
  onNoTimeFound() {

    this.resetLayers();
    this.emptyHeatmatrix();
    this.heatmatrix.close();
    this.alertList.update([], false, null);
    this.alertList.close();
    this.eraseDateList();
    this.resetMapData();
    this.resetLayerToggleButtons();
    this.resetLegends();
    this.snackBar.open("Nenhuma Informação Recebida", "", { duration: 3000 });
  }

  /**
   * Esconde as legendas de chuvas (contínua e discreta), ocorrências,
   * contagem de ocorrências por célula de voronoi, e de câmeras.
   */
  private resetLegends() {
    this.legendGroup.updateRainLegends(this.mapConfig);
    this.legendGroup.updateEventsLegend(false);
    this.legendGroup.updateVoronoiLegend(false, null);
    this.legendGroup.updateCameraLegend(false);
  }

  /**
   * Desliga os botões de exibir as camadas. Os botões de vias e rios
   * não são alterados.
   */
  private resetLayerToggleButtons() {

    this.mapConfig.layer.list[HeatmapType.STATIONS].isActive = false;
    this.mapConfig.layer.list[HeatmapType.HEATMAP].isActive = false;
    this.mapConfig.layer.list[HeatmapType.EVENTS].isActive = false;
    this.mapConfig.layer.list[HeatmapType.VORONOI].isActive = false;
    this.mapConfig.layer.list[HeatmapType.CAMERA].isActive = false;
  }

  /**
   * 
   */
  private resetLayerColors() {

    this.mapConfig.layer.list[HeatmapType.STATIONS].color = ColorType.CONSTANT;
    this.mapConfig.layer.list[HeatmapType.HIGHWAYS].color = ColorType.CONSTANT;
    this.mapConfig.layer.list[HeatmapType.RIVERS].color = ColorType.CONSTANT;
    this.mapConfig.layer.list[HeatmapType.NEIGHBORHOOD].color = ColorType.CONSTANT;
  }

  /**
   * Remove as camadas de pontos, pinta as camadas de vias, rios e
   * bairros de cinza, e remove a camada de voronoi.
   */
  private resetLayers() {

    let rainLayerIds = [HeatmapType.STATIONS, HeatmapType.HEATMAP, 
      HeatmapType.HIGHWAYS, HeatmapType.RIVERS, HeatmapType.NEIGHBORHOOD];

    for (let config of this.layers) {
      if (rainLayerIds.includes(config.id)) {
        continue;
      }
      this.toggleLayer(config.id, false);
    }

    this.resetRainLayers();
  }

  /**
   * Reinicia as camadas de dados de chuvas.
   */
  private resetRainLayers() {
    // // Mudar a cor das estações e heatmap
    this.stationHighlightLayer.remove(this.map);
    this.neighborhoodHighlightLayer.remove(this.map);
    this.toggleLayer(HeatmapType.STATIONS, false);
    this.toggleLayer(HeatmapType.HEATMAP, false);

    // Mudar a cor das vias, rios e bairros para cinza
    let highwayLayer = this.layers[HeatmapType.HIGHWAYS].layer as LineLayer;
    highwayLayer.unsetColor(this.map, { segmentsData: this.highwaysData });
    
    let riverLayer = this.layers[HeatmapType.RIVERS].layer as LineLayer;
    riverLayer.unsetColor(this.map, { segmentsData: this.riversData });
    
    let neighborhoodLayer = this.layers[HeatmapType.NEIGHBORHOOD].layer as NeighborhoodLayer;
    neighborhoodLayer.unsetColor(this.map, {
      active: this.mapConfig.layer.list[HeatmapType.NEIGHBORHOOD].isActive,
      neighborhoodsData: this.neighborhoodsData
    });
  }

  /**
   * Remove os dados geográficos do componente, pois esses já não são
   * válidos para o instante de tempo atual.
   */
  private resetMapData() {
    
    // Remover os valores de estações, ocorrências, voronoi, etc
    this.mapConfig.geoData.stations = null;
    this.mapConfig.geoData.filteredStations = null;
    this.mapConfig.geoData.middleIndicesPluv = null;
    this.eventsData = null;
    this.voronoiEventsCount = null;
    this.camerasData = null;
    this.calcNeighborhoods = null;
    this.alertsData = null;
  }

  /**
   * Limpa os conteúdos de estações e bairros da heatmatrix.
   */
  protected emptyHeatmatrix() {
    this.heatmatrix.updateTable([], []);
  }

  /**
   * Acessa uma feature collection de segmentos
   * @param index tipo dos dados, vias ou rios.
   * @returns referência à feature collection relacionada ao index
   */
  protected getSegmentsData(index: number) {
    
    if (index == HeatmapType.HIGHWAYS) {
      return this.highwaysData;
    }
    if (index == HeatmapType.RIVERS) {
      return this.riversData;
    }
    return null;
  }

  /**
   * Atualiza a exibição das camadas que usam dados das chuvas: estações, heatmap, vias, rios e bairros.
   */
  updateRainLayers() {

    const { STATIONS, HEATMAP, HIGHWAYS, RIVERS, NEIGHBORHOOD } = HeatmapType;
    const rainLayerIds = [STATIONS, HEATMAP, HIGHWAYS, RIVERS, NEIGHBORHOOD];

    for (let id of rainLayerIds) {
      let layerItem = this.mapConfig.layer.list[id];
      if (layerItem == null) {
        continue;
      }
      let status = layerItem.isActive;
      this.toggleLayer(id, status);
    }
  }

  /**
   * Método genérico para exibir os dados de qualquer camada.
   * Se os dados não tiverem sido processados ainda, processá-los antes de enviar para a camada.
   * @param layerId identificador da camada usado para acessá-la no array layers.
   * @param status indica se a camada está ativa ou não.
   */
  toggleLayer(layerId: HeatmapType, status?: boolean) {

    let {layer, beforeShow, dataFunction, updateLegendFunction} = this.layers[layerId];
    let layerParams: LayerParams = dataFunction();
    
    layer.remove(this.map);
    if (beforeShow != null) {
      beforeShow();
    }

    let layerConfig = this.mapConfig.layer.list[layerId];
    
    if (layer.hasData(layerParams) === false) {
      layerConfig.isActive = false;
      return;
    }
    
    layerConfig.isActive = status == null ? !layerConfig.isActive : status;

    if (updateLegendFunction) {
      updateLegendFunction(layerParams);
    }
    
    if (layerConfig.isActive) {
      layer.show(this.map, layerParams);
    }
  }

  /**
   * Remove a camada de destaque de uma estação selecionada. A camada de destaque
   * é representada como um círculo vermelho em torno da base do pin da estação.
   */
  removeStationHighlight() {
    // Remove destaque de estação selecionada
    this.mapConfig.geoData.filteredStations?.features?.forEach(feature => {
      feature.properties.active = false;
    });
    this.setHeatMatrixRowId(-1);
    this.stationHighlightLayer.remove(this.map);
  }

  /**
   * Remove a camada de destaque do bairro. O destaque é uma borda vermelha em
   * torno do bairro selecionado.
   * @returns 
   */
  removeNeighborhoodHighlight() {

    this.setMatrixSelectedNeighborhood(null);
    this.neighborhoodHighlightLayer.remove(this.map);

    if (this.calcNeighborhoods == null) {
      return;
    }

    for (let centroid of this.calcNeighborhoods) {
      centroid.properties['active'] = false;
    }
  }

  /**
   * Atualiza as legendas discreta e contínua das camadas de chuva.
   * As camadas que usam estas legendas são as das estações, heatmap, vias, rios e bairros.
   * @param layerParams tem os dados a serem exibidos na camada.
   */
  updateRainLegend(layerParams: LayerParams) {
    this.legendGroup.updateRainLegends(this.mapConfig);
  }

  /**
   * Atualiza a legenda da camada do diagrama de voronoi. A camada de voronoi
   * cria um diagrama de voronoi, particionando o mapa em células de modo que
   * cada célula tenha 0 ou 1 estação, e então colore a célula de acordo com
   * a contagem de ocorrências registradas na região da célula em um intervalo
   * de tempo. Assim, a camada de voronoi tenta relacionar uma estação com
   * o número de ocorrências próximas dela.
   * @param layerParams tem os dados a serem exibidos na camada de voronoi.
   */
  updateVoronoiLegend(layerParams: LayerParams) {
    let status = this.mapConfig.layer.list[HeatmapType.VORONOI].isActive;
    let middleCounts = status? this.calcEventMiddleCounts() : [];
    this.legendGroup.updateVoronoiLegend(status, middleCounts);
  }

  /**
   * Atualiza a legenda da camada dos pins das ocorrências.
   * @param layerParams tem os dados a serem exibidos na camada.
   */
  updateEventsLegend(layerParams: LayerParams) {
    let status = this.mapConfig.layer.list[HeatmapType.EVENTS].isActive;
    this.legendGroup.updateEventsLegend(status);
  }

  /**
   * Atualiza a legenda da camada dos pins das câmeras.
   * @param layerParams tem os dados a serem exibidos na camada.
   */
  updateCameraLegend(layerParams: LayerParams) {
    let status = this.mapConfig.layer.list[HeatmapType.CAMERA].isActive;
    this.legendGroup.updateCameraLegend(status);
  }

  /**
   * Atualiza a legenda da camada do heatmap de ocorrências.
   * Esta camada cria uma grade na região da cidade e conta o número de ocorrências
   * registradas nas células da grade em um intervalo de tempo. Então, ela é
   * exibida como um heatmap que indica as regiões na cidade que tiveram
   * um maior número de ocorrências registradas.
   * @param layerParams tem os dados a serem exibidos na camada.
   */
  updateEventHeatmapLegend(layerParams: LayerParams) {
    let status = this.mapConfig.layer.list[HeatmapType.EVENTS_HEATMAP].isActive;
    let { middleCounts } = layerParams;
    this.legendGroup.updateEventsHeatmapLegend(status, middleCounts);
  }

  /**
   * Cria os dados no formato para exibição na camada das estações.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getStationLayerData() {

    let { filteredStations } = this.mapConfig.geoData;
    
    let points: FeatureCollection<Point> = {type:'FeatureCollection', features: []};
    if (filteredStations != null) {
      points.features = filteredStations.features.filter(f => f.properties['indice_pluv'] != -1);
    }

    let layerParams: LayerParams = {
      points,
      selectedTimestamp: this.mapConfig.geoData.selectedColumn,
      timeColumns: this.timeColumns,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada do heatmap.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getHeatmapLayerData() {

    let { filteredStations, middleIndicesPluv, selectedColumn } = this.mapConfig.geoData;
    let { tilesizeInKm, list } = this.mapConfig.layer;

    let layerParams: LayerParams = {
      rainData: filteredStations,
      colorType: list[HeatmapType.HEATMAP].color,
      tilesize: tilesizeInKm,
      middleIndicesPluv,
      selectedTimestamp: selectedColumn,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada das vias.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getHighwayLayerData() {

    let { filteredStations, middleIndicesPluv, selectedColumn } = this.mapConfig.geoData;

    let layerParams: LayerParams = {
      selectedTimestamp: selectedColumn,
      segmentsData: this.highwaysData,
      rainData: filteredStations,
      middleIndicesPluv,
      p: this.p,
      colorType: this.mapConfig.layer.list[HeatmapType.HIGHWAYS].color,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada dos rios.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getRiverLayerData() {

    let { filteredStations, middleIndicesPluv, selectedColumn } = this.mapConfig.geoData;

    let layerParams: LayerParams = {
      selectedTimestamp: selectedColumn,
      segmentsData: this.riversData,
      rainData: filteredStations,
      middleIndicesPluv,
      p: this.p,
      colorType: this.mapConfig.layer.list[HeatmapType.RIVERS].color,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada dos bairros.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getNeighborhoodLayerData() {

    let { filteredStations, selectedColumn } = this.mapConfig.geoData;
    let layerParams: LayerParams = {
      selectedTimestamp: selectedColumn,
      rainData: filteredStations,
      calcNeighborhoods: this.calcNeighborhoods,
      neighborhoodsData: this.neighborhoodsData,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada das células de voronoi.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getVoronoiLayerData() {

    let middleCounts = this.calcEventMiddleCounts();
    let layerParams: LayerParams = {
      voronoiEventsCount: this.voronoiEventsCount,
      middleCounts: middleCounts,
      voronoiData: this.voronoiData,
    };
    return layerParams;
  }

    /**
   * Cria os dados no formato para exibição na camada das ocorrências.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getEventLayerData() {
    let layerParams: LayerParams = {
      points: this.eventsData,
    }
    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada das câmeras.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getCameraLayerData() {

    let layerParams: LayerParams = {
      points: this.camerasData,
    };

    return layerParams;
  }

  /**
   * Cria os dados no formato para exibição na camada do heatmap das ocorrências.
   * @returns objeto com os dados necessários para exibir a camada.
   */
  getEventHeatmapLayerData() {

    if (this.rainPatternEvents == null) {
      let layerParams: LayerParams = {
        gridData: null,
        middleCounts: [],
      };
      return layerParams;
    }

    let tilesizeInKm = 0.5;
    let squareGridCounts = this.countEventsInCells(this.rainPatternEvents, tilesizeInKm);
    let quartiles = this.getQuartiles(squareGridCounts);
    let normalizer = NormalizerAux.createNormalizer(quartiles, (quartile) => quartile);

    squareGridCounts.features.forEach(f => {
      f.properties.normalizedTotalCell = normalizer(f.properties.totalCell);
      f.properties.color = d3.interpolateYlOrBr(f.properties.normalizedTotalCell);
    });

    let layerParams: LayerParams = {
      gridData: squareGridCounts,
      middleCounts: quartiles,
    };

    return layerParams;
  }

  /**
   * Agrega os pontos das ocorrências em uma grade quadriculada.
   * @param layerParams parâmetros de configuração da camada, com os pontos das ocorrências e tilesize.
   * @returns feature collection da grade quadriculada na qual cada célula conta o número de ocorrências.
   */
  countEventsInCells(eventsData: FeatureCollection<Point>, tilesize: number) {
  
    let sum = (accumulator: number, current: number) => accumulator + current;
    let bbox = turf.bbox(eventsData);
    let squareGrid = turf.squareGrid(bbox, tilesize, { units: 'kilometers', });
    let squareGridCounts = turf.collect(squareGrid, eventsData, 'qtd', 'arrayCell');
    squareGridCounts.features.forEach(f => {
      f.properties.totalCell = f.properties.arrayCell.reduce(sum, 0);
    });

    return squareGridCounts;
  }
  
  /**
   * Obtêm os percentis 10, 50, e 90 de uma grade de contagem de valores.
   * @param squareGridCounts feature collection de uma grade na qual cada célula tem um valor
   * @returns array dos percentis [10, 50, 90]
   */
  getQuartiles(squareGridCounts: FeatureCollection<Polygon>) {

    let counts = squareGridCounts.features.map(f => f.properties.totalCell);
    counts = counts.sort((a: number, b: number) => a - b);
    counts = counts.filter(c => c > 0);
    let countsSet = new Set(counts);
    let q1 = d3.quantile(countsSet, 0.1);
    let q2 = d3.quantile(countsSet, 0.5);
    let q3 = d3.quantile(countsSet, 0.9);

    return [q1, q2, q3];
  }

  /**
   * Liga ou desliga o tipo do heatmap (estações, interpolação, vias, rios) na toolbar,
   * de acordo com a seleção do usuário na interface do mapa (botões de toggle).
   *
   * @param heatmapId número do tipo do heatmap (0 = estações, 1 = interpolação,
   *    2 = vias, 3 = rios)
   */
  setToolbarHeatmapType(heatmapId: number) {
    this.toolbar.heatmaptype[heatmapId] = this.mapConfig.layer.list[heatmapId].isActive;
  }

  /**
   * Escolhe os percentis de índices pluviométricos que podem ser usados na exibição do heatmap
   * interpolado, de acordo com o tipo do heatmap escolhido pelo usuário.
   *
   * @param heatmaptype tipo do heatmap: 1 para interpolação, 2 para vias, 3 para ambos.
   * @param isHighwaysDiscrete indica se as cores das vias são discretas ou não.
   * @param percentile percentis inferior e superior selecionados (ex.: 10 e 90 para 10-percentil e 90-percentil)
   * @param discretePercentiles percentis selecionados (ex.: 25, 50 e 75)
   * @returns o array de percentis inferior e superior apropriado, de acordo com a escolha do usuário.
   */
  getRange(heatmaptype: number, isHighwaysDiscrete: boolean, percentile: number[], discretePercentiles: number[]): number[] {

    if (heatmaptype == 1)
      return [10, 90];

    if (isHighwaysDiscrete)
      return [discretePercentiles[0], discretePercentiles[discretePercentiles.length - 1]];

    return percentile;
  }

  /**
   * Trata o click em uma coluna de acumulado de chuva na heatmatrix.
   * Atualiza o mapa para colorir as camadas de acordo como o acumulado selecionado.
   * @param selectedTimestamp nome do acumulado de chuva clicado na heatmatrix.
   */
  updateOnTimestamp(selectedTimestamp: string){
    this.mapConfig.geoData.selectedColumn = selectedTimestamp;
    this.updateHeatMap(false);
  }

  /**
   * Coloca um destaque vermelho em uma estação ou bairro correspondente a uma linha
   * da heatmatrix.
   * @param feature dados do ponto correspondente à linha clicada na heatmatrix.
   */
  setHighlight(feature: Feature<GeoJSON.Point>){
      if(feature.properties.neighborhood){
        this.setNeighborhoodHighlight(feature)
      } else {
        this.setStationHighlight(feature)
      }
  }

  /**
   * Coloca um destaque vermelho em um ponto da estação.
   * @param station estação destacada.
   */
  setStationHighlight(station: Feature<GeoJSON.Point>){

    this.stationHighlightLayer.remove(this.map);

    // limpa a linha da estação selecionada da heatmatrix
    this.setHeatMatrixRowId(-1);
    station.properties.active = ! station.properties.active;

    if (station?.properties?.active == false){
      return;
    }
    
    if (this.mapConfig.layer.list[HeatmapType.STATIONS].isActive == false) {
      return;
    }

    // define o estado de todas as outras estações como inativas
    this.mapConfig.geoData.filteredStations.features.forEach(f => {
      f.properties.active = false;
    });
    station.properties.active = true;

    // define a linha da estação selecionada da heatmatrix
    this.setHeatMatrixRowId(station.properties.id);

    let pointFeatureCollection: FeatureCollection<Point> = {
      'type': 'FeatureCollection',
      'features': [
        station
      ]
    };
    let layerParams: LayerParams = { rainData: pointFeatureCollection };
    this.stationHighlightLayer.show(this.map, layerParams);
  }

  /**
   * Define o valor do id da estação da linha selecionada na heatmatrix.
   * @param rowId id da estação selecionada
   */
  setHeatMatrixRowId(rowId: number) {
    this.heatmatrix.selectedId = rowId;
  }

  /**
   * Atualiza o componente da lista de datas que possuem um dado padrão de intensidade
   * de chuvas selecionado heatmatrix.
   * @param result par id da estação, lista de tempos a ser colocado na datelist.
   */
  updateDateList(result :[string,any[]]){
    // let tempo : Tempo = {id_tempo: this.toolbar.tempo.id_tempo,hora:parseInt(this.toolbar.hour.substring(0,2)),minuto: parseInt(this.toolbar.hour.substring(3,5)),
    // dia: parseInt(this.toolbar.date.substring(8,10)),mes:parseInt(this.toolbar.date.substring(5,7)),ano:parseInt(this.toolbar.date.substring(0,4))}
    this.heatmatrix.setDateListLastDate(this.mapConfig.time.tempo[0]);
    this.heatmatrix.setDateListLastEndDate(this.mapConfig.time.tempo[1]);
    this.heatmatrix.updateDateList(result);
  }

  /**
   * Atualiza as datas do instante de chuva e tempo limite de ocorrências 
   * na toolbar, disparando o evento de confirmação na toolbar para 
   * iniciar uma consulta no mapa.
   * @param dates par instante de chuva, instante limite de ocorrências.
   */
  searchDate(dates: Tempo[]){
    let date = dates[0];
    let endDate = dates[1];
    this.toolbar.startDate = `${date.ano}-${date.mes}-${date.dia}`;
    let limitDate, formattedhour, formattedminute, formattedmonth, formattedday;

    if (date.hora < 10) {formattedhour = "0"+date.hora} else { formattedhour=date.hora.toString()};
    if (date.minuto < 10) {formattedminute = "0"+date.minuto} else { formattedminute=date.minuto.toString()};
    if (date.mes < 10) {formattedmonth = "0"+date.mes} else { formattedmonth=date.mes.toString()};
    if (date.dia < 10) {formattedday = "0"+date.dia} else { formattedday=date.dia.toString()};
    this.mapConfig.time.startTime = `${formattedhour}:${formattedminute}`;
    this.mapConfig.time.startDate = `${date.ano}-${formattedmonth}-${formattedday}`;

    // Data limite das ocorrências ou data final do intervalo de chuvas.
    // Se a data final for null, define como 1 dia a partir da data inicial. 
    if (endDate == null) {
      limitDate = new Date(`${this.toolbar.startDate} ${this.toolbar.startTime}`);
      limitDate.setDate(limitDate.getDate() + 1);
    }
    else {
      limitDate = new Date(endDate.ano, endDate.mes - 1, endDate.dia, endDate.hora, endDate.minuto);
    }

    this.mapConfig.time.endDate = `${limitDate.getFullYear()}-${limitDate.getMonth() + 1}-${limitDate.getDate()}`;
    // 'hh:mm:ss'.slice(0, 5) -> 'hh:mm'
    this.mapConfig.time.endTime = limitDate.toLocaleTimeString().slice(0, 5);

    this.toolbar.updateMap(false);
  }


  /**
   * Solicita à heatmatrix para apagar o conteúdo da lista de datas que
   * possuem um padrão de chuva.
   */
  eraseDateList(){
    this.heatmatrix.eraseDateList();
  }

  /**
   * Ao receber dados dos alertas, atualiza a tabela dos alertas.
   *
   * @param alertsAndTime Um Array contendo os alertas que foram buscados e o tempo deles(Usado para funcionalidades de tempo real)
   */
  onAlertsFetched(alertsAndTime:[Alerta[],Tempo]) {
    this.alertList.update(alertsAndTime[0],this.toolbar.enabledRT,alertsAndTime[1]);
  }

  /**
   * Recolore as regiões poligonais desenhadas no mapa, de acordo com a coluna
   * de agregado de chuva selecionada correntemente.
   * @param regions regiões a serem recoloridas.
   */
  recolorAreas(regions:Feature<Point>[][]){
    let index = this.heatmatrix.displayState - 1
    regions.forEach(val=>{
      MapboxDrawCustom.recolorFeature(this.map_draw,val[index],this.mapConfig.geoData.selectedColumn)
    })

  }


  /**
   * Função chamada quando faz uma nova busca de dados para o mapa, como a heatmatrix inteira é reconstuida pra se adequar ao novo mapa
   * essa função recalcula o valor dos índices do polígono e joga eles na heatmatrix de volta
   *
   * @param polygon polígono da area atual
   */
  reloadArea(polygon:any){
    let name = polygon.properties.nome_estacao_original ? polygon.properties.nome_estacao_original : polygon.properties.name;
    let pointFeature = this.switchTypeOfPointFromPolygon(polygon,name)
    this.heatmatrix.addRegionToTable(pointFeature)
    let index = this.heatmatrix.displayState - 1
    MapboxDrawCustom.recolorFeature(this.map_draw,pointFeature[index],this.mapConfig.geoData.selectedColumn)
  }

  /**
   * Escole qual a forma de calculo que o polígono vai utilizar:
   * Caso o heatmap esteja ativado, a área vai ser calculada pensando nos valores de cada quadrado da grid
   * Caso ele esteja desativado, a área vai ser calculada pensando nos valores projetodos das ruas
   */
  switchTypeOfPointFromPolygon(polygon: any,name: string) : Feature<Point>[]{
    const list = this.mapConfig.layer.list;

    if (list[HeatmapType.HEATMAP].isActive) {

      const stationPoint = this.mapManager.pointFromPolygonUsingGrid(
        polygon,
        name,
        this.mapConfig.geoData.filteredStations,
        list[HeatmapType.STATIONS].color,
        this.timeColumns,
        this.mapConfig.layer.percentile
      );

      const neighborhoodPoint = this.mapManager.pointFromPolygonUsingGrid(
        polygon,
        name,
        this.mapConfig.geoData.filteredStations,
        list[HeatmapType.NEIGHBORHOOD].color,
        this.timeColumns,
        this.mapConfig.layer.percentile
      );

      return [stationPoint, neighborhoodPoint];
    }

    const stationPoint = this.mapManager.pointFromPolygonUsingHighways(
      polygon,
      name,
      this.mapConfig.geoData.filteredStations,
      list[HeatmapType.STATIONS].color,
      this.timeColumns,
      this.highwaysData.features,
      this.mapConfig.layer.percentile
    );

    const neighborhoodPoint = this.mapManager.pointFromPolygonUsingHighways(
      polygon,
      name,
      this.mapConfig.geoData.filteredStations,
      list[HeatmapType.NEIGHBORHOOD].color,
      this.timeColumns,
      this.highwaysData.features,
      this.mapConfig.layer.percentile
    );

    return [stationPoint, neighborhoodPoint];

  }



  /**
   * Obtém os números de ocorrências contadas nas células de voronoi que estão \
   * entre os percentis 10 e 90.
   * @returns array das contagens de ocorrências que estão entre os percentis inferior e superior.
   */
  calcEventMiddleCounts() {

    let middleCounts: number[] = [];
    let eventsCount = this.voronoiEventsCount;

    if (eventsCount == null || eventsCount.length == 0) {
      return middleCounts;
    }

    // TODO: implementar campos de percentis de contagem de ocorrências
    let percentiles = [10, 90];

    // Obter os números de ocorrências nos percentis
    let allCounts = eventsCount.map(row => +row.qtd_ocorrencias).sort((a, b) => a - b);
    middleCounts = MathAux.createMiddleData(allCounts, percentiles);
    
    return middleCounts;
  }

  /**
   * Atualizar a camada das células de voronoi no mapa, colorindo as células
   * de acordo com uma escala de número de ocorrências construída usando
   * percentis inferior e superior selecionados pelo usuário.
   * 
   * @param eventsCount 
   */
  onVoronoiEventsCount(eventsCount: VoronoiEventsCount[]) {

    this.voronoiEventsCount = eventsCount;

    let active = this.mapConfig.layer.list[HeatmapType.VORONOI].isActive;
    let middleCounts = this.calcEventMiddleCounts();
    let hasMiddleCounts = middleCounts.length > 0;
    let status = active && hasMiddleCounts;
    this.toggleLayer(HeatmapType.VORONOI, status);
  }

  /**
   * Usa os dados das estações para interpolar a chuva nos centroides dos bairros.
   * 
   * @returns array de features dos bairros com chuva interpolada.
   */
  calcNeighborhoodData(){
    let neighborhoods: Feature<Point>[] = []
    this.neighborhoodsData.features.sort((a,b)=>{
      if(a.properties.name < b.properties.name) return -1
      if(a.properties.name > b.properties.name) return 1
      return 0
    })
    let i =0;
    let auxFeatures : any[];
    while (i < this.neighborhoodsData.features.length){
      let neighborhood
      let j = i + 1
      let maxPolIndex = 0
      auxFeatures = []
      auxFeatures.push(this.neighborhoodsData.features[i]);
      let polygonfix = this.neighborhoodsData.features[i].geometry as any;
      let maxArea = parseFloat(d3.polygonArea(polygonfix.coordinates[0][0]).toString().slice(0,1));
      while(j < this.neighborhoodsData.features.length && this.neighborhoodsData.features[i].properties.name == this.neighborhoodsData.features[j].properties.name){
        auxFeatures.push(this.neighborhoodsData.features[j]);
        polygonfix = this.neighborhoodsData.features[j].geometry as any;
        let polArea = parseFloat(d3.polygonArea(polygonfix.coordinates[0][0]).toString().slice(0,1));
        if(maxArea < polArea) {maxPolIndex = j-i;maxArea = polArea}
        j++;
      }
      neighborhood = this.mapManager.pointFromPolygonNeightborhood(auxFeatures,auxFeatures[0].properties.name,this.mapConfig.geoData.filteredStations,this.timeColumns,maxPolIndex,this.mapConfig.layer.percentile)
      neighborhoods.push(neighborhood)
      i += auxFeatures.length
    }
    this.mapManager.createAllTimeStampColors({"type":"FeatureCollection","features":neighborhoods},
      this.mapConfig.layer.percentile,this.mapConfig.layer.list[HeatmapType.NEIGHBORHOOD].color,this.timeColumns.map( (val)=>{ return val.name }),this.mapConfig.geoData.filteredStations);

    return neighborhoods
  }

  /**
   * Usa os pontos das estações para interpolar a chuva nos centroides dos bairros.
   * @param points pontos das estações com os acumulados de chuva registrados.
   * @param polygons polígonos onde as chuvas serão interpoladas.
   * @param timeColumns nome dos agregados de chuvas.
   * @param percentile percentis
   */
  interpolateOnPolygons(
    points: FeatureCollection<Point>, 
    polygons: FeatureCollection<MultiPolygon|Polygon>,
    timeColumns: { name: string, text: string }[],
    percentile: [number, number],
    selectedLayerCode: HeatmapType) {

    // 1) obter o centroide do polígono de maior área de cada feature
    let centroids: Feature<Point>[] = polygons.features.map((feature) => {

      let geom = feature.geometry;
      let multiPolygons = geom.coordinates;

      let featureMaxPolygonArea = 0;
      let mainPolygon;

      // Nos nossos dados, polygon é um array de 1 elemento.
      // Esse elemento é um array de linhas que fazem o polígono. 
      // Cada linha é um array de coordenadas.
      // Cada coordenada é um array com 2 elementos: lat e long
      for (let multiPolygon of multiPolygons) {

        let polygon = (geom.type == 'MultiPolygon' ? multiPolygon[0] : multiPolygon) as [number, number][];
        
        let polygonArea = Math.abs(d3.polygonArea(polygon));

        if (polygonArea >= featureMaxPolygonArea) {
          featureMaxPolygonArea = polygonArea;
          mainPolygon = polygon;
        }
      }

      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: d3.polygonCentroid(mainPolygon)
        },
        properties: {
          ...feature.properties, 
          nome_estacao_original: feature.properties.name, 
          color: {}
        },
      } as Feature<Point>

    });

    // 2) calcular o valor interpolado nos centroides
    for (let col of timeColumns) {

      for (let centroid of centroids) {

        let [ long, lat ] = centroid.geometry.coordinates;
        let sumWeights = getStationWeights(points, lat, long, 2);
        let interpolatedValue = getPredictedRainValue(points, sumWeights, col.name);
        centroid.properties[col.name] = MathAux.round(interpolatedValue, 4);
      }
    }

    let fc: FeatureCollection<Point> = {
      'type': 'FeatureCollection',
      'features': centroids,
    }

    // 3) colorir os centroides
    let selectedLayer = this.mapConfig.layer.list[selectedLayerCode];
    this.mapManager.createAllTimeStampColors(
      fc, 
      percentile, 
      selectedLayer.color, 
      timeColumns.map(col => col.name), 
      points);

    return centroids;
  }

  /**
   * Coloca um destaque vermelho em um bairro correspondente a uma linha
   * clicada seção de bairros na heatmatrix.
   * @param neighborhood dados do bairro clicado.
   */
  setNeighborhoodHighlight(neighborhood: Feature<GeoJSON.Point>){

    this.neighborhoodHighlightLayer.remove(this.map);

    if (neighborhood.properties.erase) {
      return;
    }

    let area = this.neighborhoodsData.features.filter((val)=>{return val.properties.name == neighborhood.properties.nome_estacao_original})
    let { nome_estacao_original } = neighborhood.properties;

    this.setMatrixSelectedNeighborhood(nome_estacao_original)

    let highlightFeatureCollection: FeatureCollection<Geometry> = {
      'type': 'FeatureCollection',
      'features': area
    };
    let layerParams: LayerParams = {
      rainData: null,
      neighborhoodsData: highlightFeatureCollection,
    };
    this.neighborhoodHighlightLayer.show(this.map, layerParams);
  }

  /**
   * Define na heatmatrix o nome da estação que o usuário selecionou para destaque.
   * @param neighborhoodName nome do bairro selecionado
   */
  protected setMatrixSelectedNeighborhood(neighborhoodName: string) {
    this.heatmatrix.selectedNeighborhood = neighborhoodName
  }

  protected getHeatmatrix() {
    return this.heatmatrix;
  }

  /**
   * Alterna a visibilidade da barra lateral (toolbar)
   */
  toggleSidebar() {
    this.showSidebar = ! this.showSidebar;
  }

  /**
   * Emite evento routerIdentity com valor 1. Usado para ajuste da rota no navegador.
   */
  setRouterIdentity(){
    this.routerMessager.enforceRouterIdentity("1");
  }

  /**
   * Verifica se alguma análise foi fornecida pelo router. Se tiver análise, a usa para iniciar
   * os campos de filtro e visualização das camadas do mapa.
   */
  routerInit(){
    if (this.mapConfig.routed == false) {
      return;
    }
    this.mapConfig.routed = false;
    this.onNewTimeSearch();
    this.initRegionPolygons();
  }

  /**
   * Usa a análise selecionada pelo usuário para reconstruir as regiões poligonais
   * que ele desenhou no mapa.
   */
  private initRegionPolygons() {

    // Inicializa os polígonos das regiões
    this.mapConfig.geoData.polygons
      .forEach(polygon => {
        this.map_draw.add(polygon);
      });
  }

  /**
   * Obtém o array de características das camadas definido na toolbar.
   * 
   * @returns array de características das camadas.
   */
  protected getHeatmapConfig() {
    return this.toolbar.heatmapConfig;
  }
  
  /**
   * Executa a heurística de cálculo das rotas para atender às ocorrências.
   * Desenha as rotas no mapa.
   * @returns 
   */
  callHeuristic() {
    if (this.patrolCars.length === 0) {
      const message = "É necessário adicionar ao menos um veículo no mapa.";
      this.snackBar.open(message, "", {duration: 3000});
      console.log(message);
      return;
    }

    this.toolbar.isHeuristicRunning = true;

    // coordenadas das viaturas e das ocorrências
    let patrolCarsCoordinates = this.patrolCars.map(f => f.geometry.coordinates);
    let eventsCoordinates = this.eventsData ? 
      this.eventsData.features.map(f => f.geometry.coordinates)
      : [];

    var routesData: any;
    this.heuristicService.getHeuristicResultForLists(
      patrolCarsCoordinates,
      eventsCoordinates,
      this.mapConfig.time.startDate,
      this.mapConfig.time.startTime,
      this.mapConfig.time.endTime
    ).subscribe((result) => {
      routesData = result;
      console.log(routesData);
      if (this.map.getLayer('routes-line')) {
        this.map.removeLayer('routes-line');
      }
      if (this.map.getSource('routes-data-source')) {
        this.map.removeSource('routes-data-source');
      }
      this.mapManager.setRouteMapSource(this.map, 'routes-data-source', routesData);
      this.mapManager.setRouteMapLineLayer(this.map, 'routes-data-source', 'routes-line', '#870d17', 1, 4);
      this.mapManager.setRouteMouseEvents(this.map, 'routes-data-source', 'routes-line');
      
      this.toolbar.getSessionList(
        this.mapConfig.time.tempo[0].dia,
        this.mapConfig.time.tempo[0].mes,
        this.mapConfig.time.tempo[0].ano
      );

      this.toolbar.isHeuristicRunning = false;
    });
  }
  
  /**
   * Obtém os dados de uma rota obtida em uma execução anterior da heurística,
   * e desenha essa rota no mapa.
   */
  getHistoryGeometries(iterIds: number[]) {
    let iterationIds = iterIds;
    console.log({iterationIds});

    // remove camadas antigas
    if (this.map.getLayer('history-routes')) {
      this.map.removeLayer('history-routes');
    }

    if (this.map.getLayer('history-vehicles')) {
      this.map.removeLayer('history-vehicles');
    }
    
    // remove fonte antiga (mesma fonte para veículos e segmentos)
    if (this.map.getSource('history-geometries-data-source')) {
      this.map.removeSource('history-geometries-data-source');
    }

    this.legendGroup.updateRoutesLegend(false, []);
    
    if (iterationIds.length == 0) {
      return;
    }

    let routesLabels = iterationIds.map(id => `Rota ${id}`);
    if (routesLabels.length > 1) {
      routesLabels.push('Trecho em comum');
    }
    this.legendGroup.updateRoutesLegend(true, routesLabels);

    var geometriesData: any;
    this.service.getIterationGeometries(iterationIds).subscribe((result) => {
      geometriesData = result;
      console.log('geometrias buscadas', geometriesData);
      this.historyRoutesData = result;
      this.mapManager.setRouteMapSource(this.map, 'history-geometries-data-source', geometriesData);
      this.mapManager.setHistoryLayer(this.map, 'history-geometries-data-source', 'history-routes', 'history-vehicles', '#1126ba', 1, 4);
    });
  }
  
  /**
   * Remove todas as rotas da heurística do mapa. 
   */
  clearAllRoutes() {
    if (this.map.getLayer('history-routes')) {
      this.map.removeLayer('history-routes');
    }
    
    if (this.map.getLayer('history-vehicles')) {
      this.map.removeLayer('history-vehicles');
    }
    
    if (this.map.getLayer('routes-line')) {
      this.map.removeLayer('routes-line');
    }
  }
  
  /**
   * Alterna a visibilidade da camada das rotas de execuções anteriores
   * da heurística.
   */
  changeVisibilityHistoryLayer() {
    this.mapManager.setVisibilityHistoryLayer(this.map, this.toolbar.showHistoryRoutes, 'history-routes', 'history-vehicles');
  }
  
  /**
   * Alterna a visibilidade da camada das rotas da execução atual da heurística.
   */
  changeVisibilityCurrentLayer() {
    this.mapManager.setVisibilityCurrentLayer(this.map, this.toolbar.showCurrentRoutes, 'routes-line');
  }

  /**
   * Trata a mudança de índices do menu da toolbar.
   * No momento, caso o menu ativo seja o de rotas, o controle de adição de pontos
   * do mapbox gl draw deve ser adicionado. Caso contrário, deve ser removido.
   * Se houver pontos (viaturas) previamente adicionadas, elas devem ser
   * restauradas no mapa.
   * 
   * @param index índice do menu ativo no momento
   */
  onMenuIndexChanged(index: number) {

    return;
    let includePointDraw = index == ToolbarMenuIndices.ROUTES;
    // this.map.removeControl(this.map_draw);
    this.map_draw = MapboxDrawCustom.createDraw(includePointDraw);
    // this.map.addControl(this.map_draw, 'bottom-right');

    if (includePointDraw) {
      this.patrolCars.forEach((feature, index) => {
        this.map_draw.add(feature);
      });
    }
  }

  /**
   * Trata o evento de um clique em uma data no RainCalendarComponent.
   * Passa a data e a resolução de tempo para a toolbar, e dispara um evento de busca
   * por um tempo novo na toolbar.
   * @param item item com a data clicada e a resolução de tempo selecionada.
   * 
   */
  onRainCalendarItemClicked(item: RainCalendarItem) {

    const { dates, aggregateCol } = item;
    const date = dates[0];
    const dateStr = this.timespanService.formatDate(date);
    const timeStr = this.timespanService.formatTime(date);

    this.mapConfig.time.startDate = dateStr;
    this.mapConfig.time.startTime = timeStr;
    this.mapConfig.geoData.selectedColumn = aggregateCol;

    let toolbar = this.getToolbar();
    toolbar.updateMap(true);
  }

  /**
   * Trata o recebimento das ocorrências associadas a um padrão de intensidades de chuvas selecionado pelo usuário.
   * @param points 
   */
  onRainPatternEvents(points: FeatureCollection<Point>) {
    
    const [ lastDate, lastEndDate ] = this.mapConfig.time.tempo;

    this.heatmatrix.setDateListLastDate(lastDate);
    this.heatmatrix.setDateListLastEndDate(lastEndDate);

    this.rainPatternEvents = points;
    let active = this.mapConfig.layer.list[HeatmapType.EVENTS_HEATMAP].isActive;
    this.toggleLayer(HeatmapType.EVENTS_HEATMAP, active);
  }

  /**
   * Trata a exportação do zip com parâmetros e print do mapa.
   */
  onMapExported() {
    this.exportMapService.exportMap(this.map, this.mapConfig);
  }

  /**
   * Trata o evento de recebimento da lista de iterações da heurística das rotas.
   * @param iterations array de iterações a serem exibidas na tabela do histórico de iterações.
   */
  onIterationsLoaded(iterations: Iteration[]) {
    this.routeIterationTable.setDataSource(iterations);
  }

  /** Trata o evento de abertura da tabela do histórico de iterações da heurística das rotas. */
  onRouteIterationHistoryTableOpened() {
    this.routeIterationTable.open();
  }
}
